module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[73]438.6fc4664.woff2";